export default function CircularProgress(theme) {
  return {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: theme.palette.primary.mainHover,
        },
      },
    },
  };
}
